<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <label class="text-red-500">*</label> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div
                class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
              >

                <!-- emitente -->
                <div
                  @click="toggleEmitenteFields"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      DADOS DO EMITENTE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': dadosEmitente }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="dadosEmitente"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- nome do emitente -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.name"
                          v-model="store.relatosForm.name"
                          label="Nome do emitente"
                          :info="'Nome'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.name = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.name" class="text-red-600 text-sm" />
                      </div>

                      <!-- empresa -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.empresa"
                          >
                            Informe sua empresa <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="unidades"
                              :initial-value="store.relatosForm.empresa"
                              @selected-data="
                                (val) => {
                                  store.relatosForm.empresa = val
                                  store.relatosForm.unidade = store.relatosForm.empresa.value
                                }
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.empresa" class="text-red-600 text-sm" />
                      </div>

                      <!-- unidade -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="text"
                          name="relatosForm.unidade"
                          v-model="store.relatosForm.unidade"
                          label="Unidade"
                          :info="'Unidade'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.unidade = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.unidade" class="text-red-600 text-sm" />
                      </div>

                      <!-- setor / comite -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.setor"
                          v-model="store.relatosForm.setor"
                          label="Setor do emitente"
                          :info="'Setor'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.setor = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.setor" class="text-red-600 text-sm" />
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- relato -->
                <div
                  @click="toggleRelatosFields"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      RELATO
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': dadosRelato }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="dadosRelato"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >

                      <!-- descrição -->
                      <div class="md:col-span-5">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoDescript"
                          v-model="store.relatosForm.relatoDescript"
                          label="Descrição da atividade"
                          :info="'Descrição'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoDescript = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoDescript" class="text-red-600 text-sm" />
                      </div>

                      <!-- origem -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoOrigem"
                          v-model="store.relatosForm.relatoOrigem"
                          label="Origem do relato"
                          :info="'Origem'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoOrigem = null"
                            />
                          </template>
                        </BaseInput>

                      </div>

                      <!-- classificação -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.relatoClassi"
                          >
                            Classificação <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="classification"
                              :disable-keyboard="true"
                              :initial-value="store.relatosForm.relatoClassi"
                              @selected-data="
                                (val) => (store.relatosForm.relatoClassi = val?.name)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.relatoClassi" class="text-red-600 text-sm" />
                      </div>

                      <!-- empresa -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoEmpresa"
                          v-model="store.relatosForm.relatoEmpresa"
                          label="Empresa relatada"
                          :info="'Empresa'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoEmpresa = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoEmpresa" class="text-red-600 text-sm" />
                      </div>

                      <!-- unidade -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoUnidade"
                          v-model="store.relatosForm.relatoUnidade"
                          label="Unidade relatada"
                          :info="'Unidade'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoUnidade = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoUnidade" class="text-red-600 text-sm" />
                      </div>

                      <!-- setor -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoSetor"
                          v-model="store.relatosForm.relatoSetor"
                          label="Setor relatado"
                          :info="'Setor'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoSetor = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoSetor" class="text-red-600 text-sm" />
                      </div>

                      <!-- local -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoLocal"
                          v-model="store.relatosForm.relatoLocal"
                          label="Especificação do local"
                          :info="'Local'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoLocal = null"
                            />
                          </template>
                        </BaseInput>

                      </div>

                      <!-- data relato -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="date"
                          name="relatosForm.relatoDate"
                          v-model="store.relatosForm.relatoDate"
                          label="Data"
                          :info="'Data da ocorrência'"
                          :required-field="true"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoDate = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoDate" class="text-red-600 text-sm" />
                      </div>

                      <!-- setor de competência - responsavel -->
                      <div class="md:col-span-3">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.relatoCompe"
                          >
                            Setor de competência <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="setores"
                              :initial-value="store.relatosForm.relatoCompe"
                              @selected-data="
                                (val) => (store.relatosForm.relatoCompe = val?.name)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.relatoCompe" class="text-red-600 text-sm" />
                      </div>

                    </div>
                  </Transition>
                </div>

                <!-- frequencia -->
                <div
                  @click="toggleFrequenciaFields"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      FREQUÊNCIA E GRAVIDADE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': dadosFrequencia }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div v-show="dadosFrequencia" class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                      <!-- frequencia -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.frequency"
                          >
                            Frequência <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="frequency"
                              :disable-keyboard="true"
                              :initial-value="store.relatosForm.frequency"
                              @selected-data="
                                (val) => (store.relatosForm.frequency = val?.name)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.frequency" class="text-red-600 text-sm" />
                      </div>

                      <!-- gravity -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.gravity"
                          >
                            Gravidade <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="gravity"
                              :disable-keyboard="true"
                              :initial-value="store.relatosForm.gravity"
                              @selected-data="
                                (val) => (store.relatosForm.gravity = val?.name)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.gravity" class="text-red-600 text-sm" />
                      </div>

                      <!-- classificação -->
                      <div class="md:col-span-5" v-if="store.relatosForm.classification" :key="store.relatosForm.classification">
                        <h3 class="text-sm text-start sticky top-0 bg-white p-1">
                          Classificação do risco: <br>
                          <strong>
                            <section
                              class="flex text-lg uppercase"
                              :class="[store.relatosForm.classification == 'Risco Alto' ? 'text-red-500' : '', store.relatosForm.classification == 'Risco Moderado/Alto' ? 'text-red-400' : '', store.relatosForm.classification == 'Risco Substancial' ? 'text-red-600' : '', store.relatosForm.classification == 'Risco Crítico' ? 'text-red-700' : '']"
                            >
                              <label class="mt-auto mr-1">
                                {{ store.relatosForm.classification }}
                              </label>
                              <div v-for="item in skulls" :key="item">
                                <img :src="iconSkull" class="w-9 h-9">
                              </div>
                            </section>
                          </strong>
                        </h3>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- mitigação -->
                <div
                  @click="toggleMitigacaoFields"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      MITIGAÇÃO
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': dadosMitigacao }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div v-show="dadosMitigacao" class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                      <!-- comportamento -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.relatoComp"
                          >
                            Comportamento de risco <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="riscoComport"
                              :disable-keyboard="false"
                              :initial-value="store.relatosForm.relatoComp"
                              @selected-data="
                                (val) => (store.relatosForm.relatoComp = val)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.relatoComp" class="text-red-600 text-sm" />
                      </div>

                      <!-- riscos -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.relatoRisco"
                          >
                            Condição insegura
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="riscos"
                              :disable-keyboard="false"
                              :initial-value="store.relatosForm.relatoRisco"
                              @selected-data="
                                (val) => (store.relatosForm.relatoRisco = val)
                              "
                            />
                          </div>
                        </div>

                      </div>

                      <!-- ação -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="relatosForm.relatoAcao"
                          v-model="store.relatosForm.relatoAcao"
                          label="Ação imediata"
                          :info="'Ação imediata'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.relatosForm.relatoAcao = null"
                            />
                          </template>
                        </BaseInput>

                        <span name="relatosForm.relatoAcao" class="text-red-600 text-sm" />
                      </div>

                      <!-- mitigação -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.relatoMiti"
                          >
                            Mitigação controlou o risco? <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :data="resolv"
                              :disable-keyboard="true"
                              :initial-value="store.relatosForm.relatoMiti"
                              @selected-data="
                                (val) => (store.relatosForm.relatoMiti = val?.name)
                              "
                            />
                          </div>
                        </div>

                        <span name="relatosForm.relatoMiti" class="text-red-600 text-sm" />
                      </div>

                    </div>
                  </Transition>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <!-- <FloatBackPage /> -->
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { PhCaretUp, PhCloudArrowUp, PhFileArrowUp } from '@phosphor-icons/vue'
import { classification, frequency, gravity, riscoComport, riscos, resolv } from '../lookups/form'
import { dataRcd } from '../store'

export default {
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput
  },
  props: {
    descriptionTitle: String
  },
  data () {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      PhCaretUp,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataRcd.state,
      dataRcd,
      classification,
      frequency,
      gravity,
      riscoComport,
      riscos,
      resolv,
      dadosEmitente: true,
      dadosRelato: false,
      dadosFrequencia: false,
      dadosMitigacao: false,
      skulls: 0,
      iconSkull: require('@/assets/skull.webp'),

      unidades: [],
      setores: []
    }
  },
  watch: {
    'store.relatosForm.frequency': {
      handler: 'updateClassification',
      immediate: true
    },
    'store.relatosForm.gravity': {
      handler: 'updateClassification',
      immediate: true
    },
    'store.unidades': {
      handler: 'formatUnidades',
      immediate: true
    },
    'store.setores': {
      handler: 'formatSetores',
      immediate: true
    }
  },
  methods: {
    updateClassification () {
      const frequency = this.store.relatosForm.frequency
      const gravity = this.store.relatosForm.gravity

      if (frequency === 'RARO' && gravity === 'BAIXA') {
        this.skulls = 0
        return this.store.relatosForm.classification = 'Risco Trivial'
      }
      if (frequency === 'RARO' && gravity === 'MODERADA') {
        this.skulls = 0
        return this.store.relatosForm.classification = 'Risco Baixo'
      }
      if (frequency === 'RARO' && gravity === 'ALTA') {
        this.skulls = 2
        return this.store.relatosForm.classification = 'Risco Alto'
      }

      if (frequency === 'OCASIONAL' && gravity === 'BAIXA') {
        this.skulls = 0
        return this.store.relatosForm.classification = 'Risco Baixo'
      }
      if (frequency === 'OCASIONAL' && gravity === 'MODERADA') {
        this.skulls = 1
        return this.store.relatosForm.classification = 'Risco Moderado/Alto'
      }
      if (frequency === 'OCASIONAL' && gravity === 'ALTA') {
        this.skulls = 3
        return this.store.relatosForm.classification = 'Risco Substancial'
      }

      if (frequency === 'FREQUENTE' && gravity === 'BAIXA') {
        this.skulls = 0
        return this.store.relatosForm.classification = 'Risco Moderado'
      }
      if (frequency === 'FREQUENTE' && gravity === 'MODERADA') {
        this.skulls = 3
        return this.store.relatosForm.classification = 'Risco Substancial'
      }
      if (frequency === 'FREQUENTE' && gravity === 'ALTA') {
        this.skulls = 4
        return this.store.relatosForm.classification = 'Risco Crítico'
      }

      this.skulls = 0
      this.store.relatosForm.classification = ''
    },
    toggleEmitenteFields () {
      this.dadosRelato = false
      this.dadosFrequencia = false
      this.dadosMitigacao = false

      this.dadosEmitente = !this.dadosEmitente
    },
    toggleRelatosFields () {
      this.dadosEmitente = false
      this.dadosFrequencia = false
      this.dadosMitigacao = false

      this.dadosRelato = !this.dadosRelato
    },
    toggleFrequenciaFields () {
      this.dadosEmitente = false
      this.dadosRelato = false
      this.dadosMitigacao = false

      this.dadosFrequencia = !this.dadosFrequencia
    },
    toggleMitigacaoFields () {
      this.dadosEmitente = false
      this.dadosRelato = false
      this.dadosFrequencia = false

      this.dadosMitigacao = !this.dadosMitigacao
    },
    formatUnidades () {
      this.unidades = this.dataRcd.getters.getUnidades.map(item => ({
        name: item.unidade,
        value: item.cidade
      }))
    },
    formatSetores () {
      this.setores = this.dataRcd.getters.getSetores.map(item => ({
        name: item.name,
        value: item.name
      }))
    }
  }
}
</script>
